import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/machines/api/config.ts";
import { getVideoAround, IGetVideoInput } from "@/machines/api/requests/video.requests.ts";

const useGetVideoAround = (
  params: IGetVideoInput,
  options?: {
    enabled?: boolean;
    /** Poll interval in ms (e.g. live timeline auto-refresh); omit for no polling. */
    refetchInterval?: number | false;
    /** Cache lifetime override — use a short one for rolling-window keys. */
    gcTime?: number;
    /** Show the previous window's data while a new query key is fetching. */
    keepPrevious?: boolean;
  }
) => {
  const ONE_HOUR = 1000 * 60 * 60; // 1 hour in milliseconds

  const defaultEnabled = params.timestamp
    ? !!params.device_mxid && !isNaN(params.timestamp.getTime())
    : !!params.device_mxid;

  return useQuery({
    queryKey: [QUERY_KEYS.VIDEO, params],
    queryFn: ({ signal }) => getVideoAround(params, signal),
    enabled: options?.enabled !== undefined ? options.enabled : defaultEnabled,
    staleTime: ONE_HOUR, // Data stays fresh for 1 hour
    gcTime: ONE_HOUR, // Keep in cache for 1 hour (formerly cacheTime)
    refetchInterval: options?.refetchInterval ?? false,
    ...(options?.gcTime !== undefined && { gcTime: options.gcTime }),
    ...(options?.keepPrevious && { placeholderData: keepPreviousData }),
  })

}

export {
  useGetVideoAround
}